import WMSCapabilities from 'ol/format/WMSCapabilities'

// import { toggleWMS } from './handlers'
import { createTileWMS } from './map/layers'
import { addGroupLayer, map } from './map/tools'

// All WMS layers:
// GjerderAnlegg
  // Anlegg, Gjerder, PermanentSperregjerder, MidlertidigSperregjerder,
  // Fangarmer, Transport, Beitehage
// FlyttingSamling
  // Trekklei, Flyttlei, Oppsamling
// Administrative_grenser
  // Trollheimen, Trollheimen_grense, Trollheimen_avtaleomraade,
  // Trollheimen_ekspropriasjonsomraade, Rendal_renselskap,
  // Siidagrense, reinkonsesjonomrade, reinkonvensjonomr,
  // Reinbeitedistriktgrenser, Reinbeitedistrikt, Distriktnavn,
  // Reinbeiteomrade, Reinbeiteomrade_ost_finnmark, Reinbeiteomrade_vest_finnmark,
  // Reinbeiteomrade_troms, Reinbeiteomrade_nordland, Reinbeiteomrade_nord_trondelag,
  // Reinbeiteomrade_sor_trondelag, Restriksjonsgrense, Restriksjonsomrade,
// Varbeite_gr
  // Varbeite_kalv_tidlig, Varbeite_okse_simle
// Sommerbeite_gr
  // Sommerbeite_sentrhligg_lufting, Sommerbeite_lavreliggende
// Hostbeite_gr
  // Hostbeite_parringsland, Hostbeite_tidlig
// Hostvinterbeite_gr
  // Hostvinterbeite_tidlig_intensiv, Hostvinterbeite_spredt_bruk
// Vinterbeite_gr
  // Vinterbeite_sen_intensiv, Vinterbeite_tidlig
// Tamreinlag
  // Lom, Vaga, Fram, Filefjell

const getWMSserver = () =>  {
  const server = window.location.href.split('/')[2];
  let wms = 'wms';
  if (server.indexOf('utv') + server.indexOf('localhost') > -2)
    wms += '04utv.int';
  if (server.indexOf('test') > -1) wms = 'inter24test';
  return 'https://' + wms + '.nibio.no/cgi-bin/';
};

// const ns = 'https://wms.nibio.no/cgi-bin/';
const ns = getWMSserver();
const nsr = ns + 'reindrift';

const gn = 'https://wms.geonorge.no/skwms1/wms.';

export const wmsSettings = {
  // Base map WMS replacement while slow WMTS tiles are loading
  gråtoneWMS: {
    id: 'gråtoneWMS', url: `${gn}topograatone`, layers: 'topograatone', opacity: 1
  },
  // WMS årtidsbeite
  vaarbeiteWMS: {
    id: 'vaarbeiteWMS', url: nsr, layers: 'Varbeite_gr', opacity: 0.75
  },
  sommerbeiteWMS: {
    id: 'sommerbeiteWMS', url: nsr, layers: 'Sommerbeite_gr', opacity: 0.75
  },
  hostbeiteWMS: {
    id: 'hostbeiteWMS', url: nsr, layers: 'Hostbeite_gr', opacity: 0.75
  },
  hostvinterbeiteWMS: {
    id: 'hostvinterbeiteWMS', url: nsr,
    layers: 'Hostvinterbeite_gr', opacity: 0.75
  },
  vinterbeiteWMS: {
    id: 'vinterbeiteWMS', url: nsr, layers: 'Vinterbeite_gr', opacity: 0.75
  },
// Utenfor årstiddsbeite og konsesjonsområde:
  utenforWMS: {
    id: 'utenforWMS', url: nsr, layers: 'Utenfor', opacity: 0.3
  },
// WMS gjerder og anlegg
  anleggWMS: {
    id: 'anleggWMS', url: nsr, layers: 'Anlegg,Fangarmer', opacity: 0.75
  },
  midlertidigSperregjerderWMS: {
    id: 'midlertidigSperregjerderWMS', url: nsr,
    layers: 'MidlertidigSperregjerder', opacity: 0.75
  },
  sperregjerderWMS: {
    id: 'sperregjerderWMS', url: nsr,
    layers: 'PermanteSperregjerder', opacity: 0.75
  },
  transportWMS: {
    id: 'transportWMS', url: nsr, layers: 'Transport', opacity: 0.75
  },
  beitehageWMS: {
    id: 'beitehageWMS', url: nsr, layers: 'Beitehage', opacity: 0.7
  },
  linjeWMS: {
    id: 'linjeWMS', url: nsr,
    layers: 'Gjerder,PermanteSperregjerder,MidlertidigSperregjerder,Fangarmer,Transport,Beitehage',
    opacity: 0.75
  },
  punktWMS: {
    id: 'punktWMS', url: nsr, layers: 'Anlegg', opacity: 0.75
  },
// WMS Flytting/Samling
  oppsamlingWMS: {
    id: 'oppsamlingWMS', url: nsr, layers: 'Oppsamling', opacity: 0.75
  },
  flyttleiWMS: {
    id: 'flyttleiWMS', url: nsr, layers: 'Flyttlei', opacity: 0.75
  },
  trekkleiWMS: {
    id: 'trekkleiWMS', url: nsr, layers: 'Trekklei', opacity: 0.75
  },
// WMS administrative grenser
  reinbeitedistriktWMS: {
    id: 'reinbeitedistriktWMS', url: nsr,
    layers: 'Reinbeitedistriktgrenser', opacity: 0.7
  },
  reinbeiteomradeWMS: {
    id: 'reinbeiteomradeWMS', url: nsr, layers: 'Reinbeiteomrade', opacity: 0.7
  },
  siidagrenseWMS: {
    id: 'siidagrenseWMS', url: nsr, layers: 'Siidagrense', opacity: 0.75
  },
  konvensjonWMS: {
    id: 'konvensjonWMS', url: nsr, layers: 'reinkonvensjonomr', opacity: 0.7
  },
  ekspropriasjonWMS: {
    id: 'ekspropriasjonWMS', url: nsr,
    layers: 'Trollheimen_ekspropriasjonsomraade', opacity: 0.7
  },
  konsesjonWMS: {
    id: 'konsesjonWMS', url: nsr, layers: 'reinkonsesjonomrade', opacity: 0.7
  },
  avtaleWMS: {
    id: 'avtaleWMS', url: nsr, layers: 'Trollheimen_avtaleomraade', opacity: 0.7
  },
  restriksjonWMS: {
    id: 'restriksjonWMS', url: nsr,
    layers: 'Restriksjonsgrense,Restriksjonsomrade', opacity: 0.7
  },
  samebyrettsavgjørelseWMS: {
    id: 'samebyrettsavgjørelseWMS', url: nsr, layers: 'reinsamebyrettsavgjorelse', opacity: 0.7
  },
  samebyavtaleWMS: {
    id: 'samebyavtaleWMS', url: nsr, layers: 'reinsamebyavtale', opacity: 0.7
  },
  sverigeWMS: {
    id: 'sverigeWMS', url: `${gn}lantmeteriet_topo`, opacity: 0.75,
    layers: 'hydrografi_ytor,kurvor,hydrografi,kommunikation,jarnvag,fjallinformation,kraftledningar,anlaggningar,bebyggelse,bestammelser,administrativ_indelning,adresser,text'
  },
// WMS ar5 (default)
  arealtypeWMS: {
    id: 'arealtypeWMS', url: ns + 'ar5', layers: 'arealtype,AR5grenser', opacity: 0.5
  },
  ar5orthoWMS: {
    id: 'ar5orthoWMS', url: ns + 'ar5forvaltning2', layers: 'Manuskart', opacity: 1
  },
// Andre (choosable)
  eiendomWMS: {
    id: 'eiendomWMS', url: `${gn}matrikkel`,
    layers: 'eiendomsgrense,grensepunkt', opacity: 1
  },
  kommuneWMS: {
    id: 'kommuneWMS', url: `${gn}adm_enheter2`, layers: 'kommuner', opacity: 1
  },
  gnrWMS: {
    id: 'gnrWMS', url: `${gn}matrikkel`, layers: 'eiendoms_id', opacity: 1
  },
  økWMS: {
    id: 'økWMS', url: ns + 'ok_raster',
    layers: 'ok_raster_data_32,ok_raster_data_33,ok_raster_data_35', opacity: 1
  },
  hoydeWMS: {
    id: 'hoydeWMS', url: `${gn}topo`,
    layers: 'N2000Hoydekurver,N1000Hoydekurver,N500Hoydekurver,N250Hoydekurver,N50Hoydekurver,hoydekurver_5m,hoydekurver_1m,hoydetall5linje,hoydetall5punkt',
    opacity: 1
  },
  domWMS: {
    id: 'domWMS', url: `${gn}hoyde-dom`, layers: 'DOM:skyggerelieff', opacity: 1
  },
  dtmWMS: {
    id: 'dtmWMS', url: `${gn}hoyde-dtm`, layers: 'DTM:skyggerelieff', opacity: 1
  },
  ar5_13WMS: {
    id: 'ar5_13WMS', url: ns + 'ar5gpi', layers: 'GPI13klasser_fill', opacity: 0.5
  },
  ortoWMS: { // empty source until a project has been chosen
    id: 'ortoWMS', url: '', layers: 'ortofoto', opacity: 1
  }
};

const chooseCustomWMS = () => {
  const card = document.getElementById('mapLayerSelector');
  card.style.overflow = 'hidden'; // put it back to auto when closing mask
  card.scrollTop = 0;
  const mask = document.createElement('div');
  mask.id = 'wmsSelectionMask';
  const urlField = document.createElement('textarea');
  // const urlField = document.createElement('input');
  // urlField.type = 'url';
  urlField.id = 'wmsUrlField';
  // urlField.placeholder = 'URL til WMS';
  urlField.placeholder = 'URL til WMS, f.eks. https://...';
  const kommuneplaner = `${gn}kommuneplaner`;
  urlField.placeholder = 'URL til WMS, f.eks. ' + kommuneplaner;
  // urlField.rows = '5'; // did not work
  // urlField.value = kommuneplaner;
  // urlField.value = `${gn}reguleringsplaner`;
  const urlFieldLabel = document.createElement('label');
  urlFieldLabel.htmlFor = 'wmsUrlField';
  urlFieldLabel.innerHTML = 'Legg til egen tjeneste:';
  mask.appendChild(urlFieldLabel);
  mask.appendChild(urlField);
  const velg = document.createElement('a');
  velg.id = 'parseWmsLayers';
  velg.innerHTML = '&#x1F50D; Velg kartlag';
  mask.appendChild(velg);
  const msg = document.createElement('p');
  msg.id = 'getCapabilitiesFailedMsg';
  msg.innerHTML = 'Ikke noe lag, sjekk URLen!';
  msg.hidden = true;
  mask.appendChild(msg);
  const selection = document.createElement('ul'); // list of checkboxes
  let wmsVersion;
  const createLayerList = (layers, version) => {
    wmsVersion = version; // WMS version 1.1.1 or 1.3.0
    layers.forEach(layer => {
      const name = layer.Name;
      const li = document.createElement('li');
      const cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.id = 'cb_' + name;
      cb.value = name;
      // cb.checked = false;
      const label = document.createElement('label');
      label.htmlFor = cb.id;
      label.innerHTML = name;
      li.appendChild(cb);
      li.appendChild(label);
      selection.appendChild(li);
    });
  };
  const atLeastOneLayerIsSelected = () => {
    const items = selection.getElementsByTagName('li');
    const len = items.length;
    let atLeastOneLayer = false;
    for (let i = 0; i < items.length; i++) {
      if (items[i].firstChild.checked) {
        atLeastOneLayer = true;
        break;
      }
    }
    return (len > 0) && atLeastOneLayer;
  }
  // async and await are needed to catch a CORS-error
  const displayAvailableWmsLayers = async () => { // GetCapabilities
    // console.log('displayAvailableWmsLayers');
    msg.hidden = true;
    const parser = new WMSCapabilities();
    const clean = urlField.value
      .replace(/\s/g, '') // remove whitespaces
      .replace(/\?.*/, ''); // remove trailing parameters
    const getCapabilities = clean + '?REQUEST=GetCapabilities&SERVICE=WMS';
    try { await
      fetch(getCapabilities).then(
      // fetch(getCapabilities, { headers: { 'Content-Type': 'text/xml' } }).then(
        response => response.text()
      ).then(text => {
        let result;
        const xml = (text.indexOf('<?xml') === 0);
        const version_1_1_1 = (text.indexOf('<WMT_MS_Capabilities') > -1);
        const version_1_3_0 = (text.indexOf('<WMS_Capabilities') > -1);
        const capabilities = (version_1_1_1 || version_1_3_0);
        if (xml && capabilities) try { result = parser.read(text); } catch { }
        // console.log(result);
        // const name = result?.Capability?.Layer?.Name;
        const title = result?.Capability?.Layer?.Title;
        // const formats = result?.Capability?.Request?.GetMap?.Format;
        const layers = result?.Capability?.Layer?.Layer;
        const version = result?.version;
        // console.log(name, title, formats, layers);
        selection.name = title;
        selection.innerHTML = '';
        if (layers && layers.length > 0) createLayerList(layers, version);
        else msg.hidden = false;
      });
    } catch (e) { msg.hidden = false; }
    // selection.addLayers();
  };
  // urlField.onchange = displayAvailableWmsLayers;
  velg.onclick = displayAvailableWmsLayers;
  urlField.onkeydown = (e) => {
    const enter = (e.keyCode === 13 || e.key === 'Enter' || e.code === 'Enter');
    // if (enter) velg.click(); // closes window
    if (enter) { e.preventDefault(); displayAvailableWmsLayers(); }
  }
  mask.appendChild(selection);
  const removeMask = () => {
    card.style.overflow = 'auto';
    mask.remove();
  }
  // Buttons:
  const btnContainer = document.createElement('div');
  btnContainer.id = 'wmsButtonContainer';
  const avbrytBtn = document.createElement('button');
  avbrytBtn.id = 'customWmsCancellationBtn';
  avbrytBtn.innerHTML = 'Avbryt';
  avbrytBtn.onclick = removeMask;
  const bekreftBtn = document.createElement('button');
  bekreftBtn.id = 'customWmsConfirmationBtn';
  bekreftBtn.innerHTML = 'Legg til';
  bekreftBtn.onclick = () => { // load WMS
    if (atLeastOneLayerIsSelected()) {
      const layers = checkedValues(selection);
      const id = 'customWMS_' + layers.join('_');
      const h = selection.name;
      const header = h.charAt(0).toUpperCase() + h.substr(1).toLowerCase();
      addSwitchForCustomWms(id, header);
      addCustomWmsToMap(id, urlField.value, layers, wmsVersion);
      removeMask();
      // Scroll to bottom to show the new WMS:
      // card.scrollTo(0, card.scrollHeight);
      card.scrollTo({ left: 0, top: card.scrollHeight, behavior: 'smooth' });
    } else if (selection.getElementsByTagName('li').length < 1) velg.click();
  };
  btnContainer.appendChild(avbrytBtn);
  btnContainer.appendChild(bekreftBtn);
  mask.appendChild(btnContainer);

  card.appendChild(mask);
};
document.getElementById('customWmsBtn').onclick = chooseCustomWMS;

const addSwitchForCustomWms = (id, header) => {
  const cardContent = document.getElementById('hiddenForMinimapsWMS_ar5');
  let customSwitches = document.getElementById('customSwitches');
  if (!customSwitches) {
    const hr = document.createElement('hr');
    hr.style.marginTop = '10px';
    cardContent.appendChild(hr);
    const h5 = document.createElement('h5');
    h5.innerHTML = 'Egne WMSer';
    cardContent.appendChild(h5);
    customSwitches = document.createElement('div');
    customSwitches.id = 'customSwitches';
    customSwitches.className = 'row';
    cardContent.appendChild(customSwitches);
  }
  const customSwitch = document.createElement('div');
  customSwitch.className = 'col s6 switch';
  customSwitch.title = header;
  const label = document.createElement('label');
  const p = document.createElement('p');
  p.className = 'customWmsHeader';
  p.innerHTML = header;
  label.appendChild(p);
  const s = document.createElement('input');
  s.id = id;
  s.className = 'wms';
  s.type = 'checkbox';
  // s.setAttribute('type', 'checkbox');
  s.checked = true; // only this did not work for materialize
  s.setAttribute('checked', true);
  // s.onchange = toggleWMS; // did not work
  label.appendChild(s);
  label.innerHTML += 'Av ';
  const span = document.createElement('span');
  span.className = 'lever';
  label.appendChild(span);
  label.innerHTML += ' På';
  customSwitch.appendChild(label);
  customSwitches.appendChild(customSwitch);
  return;
}

const checkedValues = (selection) => {
  const items = selection.getElementsByTagName('li');
  const len = items.length;
  const layers = [];
  for (let i = 0; i < items.length; i++) {
    const cb = items[i].firstChild;
    if (cb.checked) layers.push(cb.value);
  }
  return layers;
};

const addCustomWmsToMap = (id, url, layers, version) => {
  const wms = createTileWMS(id, url, layers.join(','), .75, version);
  // map.addLayer(wms);
  addGroupLayer(map, wms);
  return;
}

